<template>
  <div class="system">
    <el-header style="height:auto">
      <mainHeader />
    </el-header>
    <el-container>
      <el-aside class="aside" style="width:230px">
        <mainMenu></mainMenu>
      </el-aside>
      <el-main class="el-main">
        <div class="el-content">
          <div class="top-list">
            <div v-for="(data, index) in topList" :key="index" class="top" :style="index ? 'margin-left: -10px' : 'margin-left: 50px'" :class="{ secondary: index + 1 === topList.length, mb: topList.length === 1 }" @click="tolink(data, index)">{{ data.title }}</div>
          </div>
          <transition name="move " mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </el-main>
    </el-container>
    <!-- 小蜜蜂新手引导 -->
    <beeGuide />
  </div>
  <!-- </div> -->
</template>

<script>
import mainMenu from "@/components/teacher/common/menu";
import mainHeader from "@/components/teacher/common/header";
import beeGuide from "@/components/teacher/common/beeGuide";
export default {
  name: 'system',
  components: {
    mainMenu,
    mainHeader,
    beeGuide
  },
  data() {
    return {
      pageIndex: '/english/system/home',
      topList: [],

    }
  },
  watch: {
    '$route'(to, from) {
      this.changeTop(to)
    },
  },
  created() {
    this.changeTop(this.$route)
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    changeTop(to) {
      if (to.meta.title == '我的班级') {
        // 我的班级
        this.topList = [{ pathName: 'myClass', title: '首页', }, { pathName: 'myClass', title: '我的班级', }]
      } else if (to.meta.title == '班级学生') {
        // 班级学生
        this.topList = [{ pathName: 'myClass', title: '首页', }, { pathName: 'myClass', title: '我的班级', }, { pathName: 'classStudent', title: '班级学生', }]
      } else if (to.meta.title == '数据面板') {
        //数据面板
        this.topList = [{ pathName: 'dataCenter', title: '数据中心', },]
      } else if (to.meta.title == '成绩数据') {
        // 成绩数据
        this.topList = [{ pathName: 'dataCenter', title: '数据中心', }, { pathName: 'achievementData', title: '成绩数据', },]
      } else if (to.meta.title == '班级成绩') {
        // 班级成绩
        this.topList = [{ pathName: 'dataCenter', title: '数据中心', }, { pathName: 'achievementData', title: '成绩数据', }, { pathName: 'classGrade', title: sessionStorage.getItem('router_class_name') },]
      } else if (to.meta.title == '学生成绩') {
        // 学生成绩
        this.topList = [{ pathName: 'dataCenter', title: '数据中心', }, { pathName: 'achievementData', title: '成绩数据', }, { pathName: 'classGrade', title: sessionStorage.getItem('router_class_name') }, { pathName: 'studentGread', title: sessionStorage.getItem('router_stu_name') },]
      } else if (to.meta.title == '对比分析') {
        // 成绩数据
        this.topList = [{ pathName: 'dataCenter', title: '数据中心', }, { pathName: 'contrastData', title: '对比分析', }]
      }  else if (to.meta.title == '集训报告') {
        // 成绩数据
        this.topList = [{ pathName: 'dataCenter', title: '数据中心', }, { pathName: 'teachersReport', title: '集训报告', }]
      }else if (to.meta.title == '兑换审核') {
        // 兑换审核
        this.topList = [{ pathName: 'exchange', title: '兑换审核', },]
      } else if (to.meta.title == '兑换进度') {
        this.topList = [{ pathName: 'exchangeProgress', title: '兑换进度', },]
      } else if (to.meta.title == '帮助中心') {
        this.topList = [{ pathName: 'myClass', title: '首页', }, { pathName: 'helpCenter', title: '帮助中心', }]
      }
    },
    //导航跳转
    tolink(data, index) {
      if (index + 1 !== this.topList.length) {
        this.$router.replace({ name: data.pathName })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.el-header {
  padding: 0;
}
.el-main {
  // position: relative;
  .el-content {
    width: 100%;
    height: calc(100% - 70px);
    padding: 20px;
    background-color: #fff;
  }
}

.system {
  height: 100%;
  width: 100%;
  //  background: #f5f5f5;
  background: #eee;
}
.el-container {
  height: 100%;
}
.top-list {
  border-bottom: #dde3e7 solid 3px;
  width: 100%;
  display: inline-block;
  text-align: start;
  .top {
    background: #eee;
    color: #666;
    font-size: 16px;
    display: inline-block;
    padding: 7px 15px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    cursor: pointer;
    border: 1px solid #ccc;
    border-bottom: 0;
  }
  .top.secondary {
    padding: 10px 15px;
    background: #dde3e7;
    border: 1px solid #ddd;
    border-bottom: 0;
    cursor: default;
    margin-bottom: -15px;
  }
  .top.secondary.mb {
    margin-bottom: -3px;
  }
  .hr {
    height: 3px;
    background: #dde3e7;
    border-radius: 10px;
  }
}
</style>





